export const MEETING_EXPENSE_ENTITY_SET = 'indskr_expenses';
export const EXPENSE_TYPE_ENTITY_SET = 'indskr_expense_types';
export const EXPENSE_SUBTYPE_ENTITY_SET = 'indskr_expense_categories';
export const ANNOTATIONS_ENTITY_SET = 'annotations';
export const CONTACT_ENTITY_SET = 'contacts';
export const CURRENCY_ENTITY_SET = 'transactioncurrencies';
export const APPOINTMENT_ENTITY_SET = 'appointments';

export const MEETING_EXPENSE_FIELDS = {
  ID: 'indskr_expenseid',
  NAME: 'indskr_name',
  DATE: 'indskr_date',
  AMOUNT: 'indskr_amount',
  STATE: 'statecode',
  STATUS: 'statuscode',
  TYPE: 'indskr_expense_type',
  SUBTYPE: 'indskr_expense_category',
  CONTACT: 'indskr_customerid',
  OWNER: 'ownerid',
  CATEGORY: 'indskr_expensecategory',
  REGARDING: 'indskr_regarding',
} as const;

// @odata.bind uses the case-sensitive navigation-property name, not the attribute name.
export const MEETING_EXPENSE_NAV = {
  TYPE: 'indskr_Expense_Type',
  SUBTYPE: 'indskr_Expense_Category',
  CONTACT: 'indskr_customerid',
  CURRENCY: 'transactioncurrencyid',
  NOTE_PARENT: 'objectid_indskr_expense',
  REGARDING: 'indskr_Regarding',
} as const;

export const EXPENSE_STATE = { ACTIVE: 0, INACTIVE: 1 } as const;

export const EXPENSE_STATUS_CODE = {
  ACTIVE: 1,
  DRAFT: 268890001,
  SUBMITTED: 268890003,
  FOR_REVIEW: 2,
  APPROVED: 548910000,
  REJECTED: 548910001,
  CANCELLED: 268890002,
} as const;

// Submitted and Cancelled are Inactive status reasons: a write that sets them must send statecode 1 too.
export const EXPENSE_STATE_FOR_STATUS: Record<number, number> = {
  [EXPENSE_STATUS_CODE.ACTIVE]: EXPENSE_STATE.ACTIVE,
  [EXPENSE_STATUS_CODE.DRAFT]: EXPENSE_STATE.ACTIVE,
  [EXPENSE_STATUS_CODE.SUBMITTED]: EXPENSE_STATE.INACTIVE,
  [EXPENSE_STATUS_CODE.FOR_REVIEW]: EXPENSE_STATE.INACTIVE,
  [EXPENSE_STATUS_CODE.APPROVED]: EXPENSE_STATE.INACTIVE,
  [EXPENSE_STATUS_CODE.REJECTED]: EXPENSE_STATE.INACTIVE,
  [EXPENSE_STATUS_CODE.CANCELLED]: EXPENSE_STATE.INACTIVE,
};

// Meeting on the expense's category picklist and on Type/Subtype's indskr_expensecategories; Draft shares the number.
export const MEETING_EXPENSE_CATEGORY = 268890001;

// indskr_date is a User Local column: the Web API exchanges UTC datetimes, not plain dates.
export const EXPENSE_DATE_IS_USER_LOCAL = true;

// Dataverse limits: a value outside them fails the write with a 400, which discards a queued offline expense.
export const MEETING_EXPENSE_NAME_MAX_LENGTH = 100;
export const MEETING_EXPENSE_MAX_AMOUNT = 922337203685477;

export const MEETING_EXPENSE_AUTOSAVE_DEBOUNCE_MS = 600;
export const MEETING_EXPENSE_INLINE_ACTIVITY_KEY = 'Expense';
export const MEETING_EXPENSE_NOTES_ACTIVITY_TYPES = ['meetingexpense', 'meetingexpenses'];
